const createClass = require('create-react-class');
const PropTypes = require('prop-types');
const DOMFactories = require('react-dom-factories');

module.exports = { createClass, PropTypes, DOMFactories };
